import { Checkbox } from "@mui/material"
import type { Row } from "@tanstack/react-table"
import type { FC } from "react"

import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"

interface GoodsReceiptPalletCheckboxCellProps {
  row: Row<GoodsReceiptPallet>
}

export const GoodsReceiptPalletCheckboxCell: FC<GoodsReceiptPalletCheckboxCellProps> = ({ row }) => {
  return (
    <Checkbox
      checked={row.getIsSelected()}
      disabled={!row.getCanSelect()}
      onChange={row.getToggleSelectedHandler()}
      data-testid='pallet-row-checkbox'
    />
  )
}
